import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../../components/ui/dialog";
import { useWorkspace } from "../../store/WorkspaceContext";
import { useAuth } from "../../store/AuthContext";
import { BulkImport } from "./BulkImport";
import { TemplateUpload } from "./TemplateUpload";

export const ImportDialog = () => {
  const { state, dispatch } = useWorkspace();
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const open = state.dialog === "import";
  const [mode, setMode] = useState("single");
  const close = () => { dispatch({ type: "SET", patch: { dialog: null, importPrefill: null } }); setMode("single"); };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className={`panel3d max-h-[90vh] ${mode === "bulk" ? "max-w-[1400px]" : "max-w-4xl"} overflow-y-auto border-[#27324a] bg-[#121824] text-[#e8e9ec]`} data-testid="import-dialog"
        onInteractOutside={(e) => { if (e.target?.closest?.("[data-testid=shot-lightbox]")) e.preventDefault(); }}
        onEscapeKeyDown={(e) => { if (document.querySelector("[data-testid=shot-lightbox]")) e.preventDefault(); }}>
        <DialogHeader>
          <DialogTitle className="text-[15px]">Upload vehicle templates</DialogTitle>
          <DialogDescription className="text-[#9aa0a8]">{mode === "bulk" ? "Drop a whole folder of vehicle files (make, model and years read from names like “BMW 3 Series GT 2014-2019.pdf”) or a pile of DigiCut / CORE screenshots — each is filed under the Year / Make / Model shown in its side panel or title bar. Review, fix any guess, then import all." : "Drop your cut files. We read the vehicle from the file name or contents, detect each window, and add the templates to the right vehicle with their exact measurements."}</DialogDescription>
        </DialogHeader>
        {isAdmin && (
          <div className="flex rounded-md border border-[#27324a] bg-[#0c1017] p-0.5 text-[12px]">
            {[["single", "One vehicle"], ["bulk", "Bulk — whole folder"]].map(([m, l]) => <button key={m} data-testid={`import-mode-${m}`} onClick={() => setMode(m)} className={`flex-1 rounded px-3 py-1.5 ${mode === m ? "bg-[#27324a] text-[#e8e9ec]" : "text-[#9aa0a8] hover:text-[#e8e9ec]"}`}>{l}</button>)}
          </div>
        )}
        {mode === "bulk" && isAdmin ? <BulkImport onClose={close} /> : <TemplateUpload key={open ? "open" : "closed"} onClose={close} />}
      </DialogContent>
    </Dialog>
  );
};
